import React from "react";
import { SvgIcon } from "@mui/material";
import PropTypes from "prop-types";
import { ReactComponent as SuccessIconSvg } from "assets/success-icon.svg";

const SuccessIcon = ({ sx }) => (
  <SvgIcon component={SuccessIconSvg} viewBox="0 0 14 14" sx={sx} />
);

SuccessIcon.propTypes = {
  sx: PropTypes.object,
};

SuccessIcon.defaultProps = {
  sx: null,
};

export default SuccessIcon;
